const initialState = {}

const updatedNotifications = (state, id) => {
  const index = state.notifications.findIndex(notification => notification.id == id)
  if (index == -1) return state.notifications

  return [
    ...state.notifications.slice(0, index), 
    { ...state.notifications[index], seen: true },
    ...state.notifications.slice(index + 1, state.notifications.length)
  ]
}

const seenAll = (state) => {
  return state.notifications.map(notification => { return {...notification, seen: true}})
}

const releasedNotifications = (state, id) => {
  const index = state.notifications.findIndex(notification => notification.id == id)
  if (index == -1) return state.notifications

  return [
    ...state.notifications.slice(0, index), 
    ...state.notifications.slice(index + 1, state.notifications.length)
  ]
}

const appendedNotifications = (state, data) => {
  return [ data, ...state.notifications ]
}

const notifications = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'NOTIFICATIONS.INIT':
      return {...state, ...payload, showGame: false}
    case 'NOTIFICATIONS.SEEN':
      return {...state, notifications: updatedNotifications(state, payload)}
    case 'NOTIFICATIONS.DELETED':
      return {...state, notifications: releasedNotifications(state, payload)}
    case 'NOTIFICATIONS.SEEN_ALL':
      return {...state, notifications: seenAll(state)}
    case 'NOTIFICATIONS.DELETED_ALL':
      return {...state, notifications: []}
    case 'NOTIFICATIONS.RECEIVED':
      return {...state, notifications: appendedNotifications(state, payload)}
    default:
      return state
  }
}

export default notifications
